<script>
    import {PATH_PREFIX, PATH_PREFIX_ABS} from '../../apiUrls.js';
	import { onMount } from 'svelte';
	import { submit } from '../Form/utils.js';
	import moment from 'moment';
    import {sgettext} from '../../i18n.js';


	export let showHeader = true;
	export let data = {
		columns: [
			{
				id: 'Work Order #',
				label: sgettext('$$WORK_ORDER_1$$'),
				fitContent: true,
			},
			{
				id: 'Instance Name',
				label: sgettext('$$INSTANCE_NAME$$'),
				fitContent: true,
			},
			{
				id: 'Status',
				label: sgettext('$$STATUS$$'),
				fitContent: true,
			},
			{
				id: 'Scheduled Start',
				label: sgettext('$$SCHEDULED_START$$'),
				fitContent: true,
			},
			{
				id: 'Date Loaded',
				label: sgettext('$$DATE_LOADED$$'),
				fitContent: true,
			},
			{
				id: 'Actions',
				label: sgettext('$$ACTIONS$$'),
				fitContent: true,
			},
		],
	};
	export let striped = true;
	export let MAX_ATTEMPT_RETRY = null;
	export let device_id = null;
	export let deviceSyncStatusUrl = `${PATH_PREFIX}/sw/v2/api/device/sync_status/`;
	export let activityVersionUrl = `${PATH_PREFIX}/sw/v2/api/device/${id}/activities/`;

	let devices = [];
	let activities = [];
	let formErrors = null;
	let selectedRow = null;

	function onRowClick(event) {
		event.stopPropagation();
		event.currentTarget.classList.add('selected');
	}

	async function getActivities() {
		const response = await fetch(`${activityVersionUrl}`);

		if(response.ok){
		    const json = await response.json();
		    for(const syncStatus of devices){
                const activityVersion = json.results.find(a => a.id === syncStatus.activity_version);
                activities.push({
                    activity_id: activityVersion.id,
                    sync_id: syncStatus.id,
                    name: activityVersion.name,
                    start_time: activityVersion.scheduled_start_time,
                    work_order: activityVersion.sap_work_order_number,
                    completed_time: syncStatus.change_completed_time,
                    instance_current_status: syncStatus.current_status,
                    instance_desired_status: syncStatus.desired_status,
                    attempt_number: syncStatus.attempt_number,
                });
            }
		    activities = [...activities];
        }
	}

	async function getDevices() {
		const response = await fetch(
			`${deviceSyncStatusUrl}?device=${device_id}`
		);
		const json = await response.json();
		try {
			if (response.ok) {
				if (json) {
					devices = json.results;
				}
			} else {
				console.error(json);
			}
		} catch (err) {
			console.error(err);
		}
	}

	function getUrl(id) {
		return `${location.protocol}//${location.host}${PATH_PREFIX_ABS}sw/builder/activityversion/${id}/detail/`;
	}

	function transformDateTime(dateTime) {
		var formattedDateTime = moment(dateTime);
		if (formattedDateTime.isValid()) {
			return formattedDateTime.format('MMM. DD, YYYY, h:mm A.');
		} else {
			return 'N/A';
		}
	}

	function setRemoveStatus(syncID) {
		return async () => {
			const data = {
				desired_status: 2,
			};
			const url = `${deviceSyncStatusUrl}${syncID}/`;
			const method = 'PATCH';
			try {
				await submit(url, method, data);
				if (!formErrors || formErrors.length === 0) {
					location.reload();
				}
			} catch (error) {
				console.error(error);
			}
		};
	}

	onMount(async () => {
		await getDevices();
		await getActivities();
	});
</script>

<style>
	.instance-status {
		box-sizing: border-box;
		min-width: 95px;
		border-radius: 1rem;
		display: block;
		padding: 0.3em 0.6em 0.3em;
		font-size: 0.8rem;
		font-weight: 700;
		line-height: 1;
		text-align: center;
		white-space: normal;
		min-width: 69px;
	}

	.instance-status-pending {
		color: white;
		background-color: #dd5900;
	}

	.instance-status-failed {
		color: white;
		background-color: #181818;
	}
</style>

<div class="container" style="padding-bottom: 42px;">

	<table class="table" class:table-striped={striped}>
		{#if data.hasOwnProperty('columns') && showHeader}
			<thead class="thead-light">
				<tr>
					{#each data.columns as col}
						<th class:fit={col.fitContent}>{col.label}</th>
					{/each}
				</tr>
			</thead>
		{/if}
		<tbody>
			{#each activities as a}
				<tr on:click={onRowClick}>
					{#if a.work_order == null}
						<td>{sgettext('$$NA$$')}</td>
					{:else}
						<td>{a.work_order}</td>
					{/if}
					<td>
						<a href={getUrl(a.activity_id)}>{a.name}</a>
					</td>
					<td>
						{#if a.attempt_number > MAX_ATTEMPT_RETRY}
							<span
								class="instance-status instance-status-failed">
								{sgettext('$$FAILED_1$$')}
							</span>
						{:else if a.instance_current_status === 1 && a.instance_desired_status === 1}
							<span
								class="instance-status instance-status-pending">
								{sgettext('$$DOWNLOADED$$')}
							</span>
						{:else if a.instance_current_status === 1 && a.instance_desired_status === 2}
							<span
								class="instance-status instance-status-pending">
								{sgettext('$$AWAITING_REMOVAL$$')}
							</span>
						{:else if a.instance_current_status === 2 && a.instance_desired_status === 1}
							<span
								class="instance-status instance-status-pending">
								{sgettext('$$AWAITING_DOWNLOAD$$')}
							</span>
						{:else if a.instance_current_status === 2 && a.instance_desired_status === 2}
							<span
								class="instance-status instance-status-pending">
								{sgettext('$$REMOVED$$')}
							</span>
						{:else}
							<span
								class="instance-status instance-status-failed">
								{sgettext('$$UNKNOWN_STATUS$$')}
							</span>
						{/if}
					</td>
					<td>{transformDateTime(a.start_time)}</td>
					<td>{transformDateTime(a.completed_time)}</td>
					{#if a.instance_current_status === 1 && a.instance_desired_status === 1}
						<td>
							<a
								role="button"
								href="javascript:void(0)"
								on:click|once={setRemoveStatus(a.sync_id)}
								class="nav-link btn-orange"
								title={sgettext('$$REMOVE$$')}>
								{sgettext('$$REMOVE$$')}
							</a>
						</td>
					{:else}
						<td />
					{/if}
				</tr>
			{/each}
		</tbody>
	</table>

</div>
